export default "__VITE_ASSET__CQhuRcEY__"